import { create } from 'zustand';

type NordesteState = {
  data: boolean;
  setNordeste: (data: boolean) => void;
};

export const useNordesteStore = create<NordesteState>(set => ({
  data: false,
  setNordeste: (data: boolean) => set({ data }),
}));
